module.exports = __webpack_public_path__ + "static/img/chu.deb69b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/chu.jpg
// module id = J4s/
// module chunks = 21